module.exports = __webpack_public_path__ + "static/media/bfree_recap.70b84895.png";